import CloseIcon from "@mui/icons-material/Close";
import FilterListIcon from "@mui/icons-material/FilterList";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  Box,
  Button,
  Drawer,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Stack,
  Tooltip,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { createColumnHelper } from "@tanstack/react-table";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { cfpBaseUrl } from "../../network/urls";
import {
  convertDate,
  convertDatewithTime,
  convertToMillions,
  numberFormatting,
  officeName,
  subdivisionName,
  getName,
} from "../../services/Functions";
import "../../style/common.scss";
import ReportExportButtons from "./components/ReportExportButtons";
import "./reportPageLayout.scss";
import "./ChangeOfAttributesStatusReport.scss";
import "./CashCollectionSummaryReport.scss";
import {
  renderCircleValue,
  renderDivisionValue,
  renderSubDivisionValue,
} from "./coaHierarchySelectRenderers";
import XLSX, { boldDomTheadRows } from "utils/xlsxStyled";
import { saveAs } from "file-saver";
import AppLoader from '../../components/AppLoader/AppLoader';
import FESCOLOGO from "../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../images/DISCO Logos/IESCO.png";
import MEPCOLOGO from "../../images/DISCO Logos/MEPCO.png";
import LESCOLOGO from "../../images/DISCO Logos/LESCO.png";
import PESCOLOGO from "../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../images/DISCO Logos/TESCO.png";
import HAZECOLOGO from "../../images/DISCO Logos/HAZECO.jpg";
import pitcLogo from "../../images/pitc.png";
import eOpsLogo from "../../images/eops.png";
import { resolveOfficeCodeForAdmin, getInitialAdminOfficeCode, getEffectiveAdminCompanyCode, resolveReportGoOfficeCode } from "../../utils/adminCompany";

const CashCollectionReport = () => {
  const columnHelper = createColumnHelper();
  const tableRef = useRef(null);

  const [assmntBatchWise, setAssmntBatchWise] = useState([]);

  const formattedAssmntBatchWise = assmntBatchWise.map((batch) => {
    let formattedBatch = {};
    Object.keys(batch).forEach((key) => {
      formattedBatch[key] =
        batch[key] != "Total" ? numberFormatting(batch[key]) : batch[key];
    });
    return formattedBatch;
  });
  // const { officeCode: offCode } = useSelector(state => state.officeCode)
  const { token, code, name, roleName, roleTypeName, cscID, cfcLevelId, selectedAdminCompanyCode } =
    useSelector((state) => state.auth);
  const companyCode = code.slice(0, 2);
  const offCode = code;
  const [chartOptionsBilling, setChartOptionsBilling] = useState({
    chart: {
      type: "bar",
      width: null,
      height: "294",
      padding: "auto",
      marginBottom: "30",
      marginTop: "-",
      marginLeft: "60",
      backgroundColor: "transparent",
    },
    title: {
      text: "",
      align: "left",
    },
    subtitle: {
      text: "",
      align: "left",
    },
    xAxis: {
      categories: [
        "Total",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "12",
        "13",
        "...",
      ],
      title: {
        useHTML: true,
        text: '<span style="letter-spacing: 7.5px; color:#BF0F15; ">Batch Number</span>', // Adjust letter-spacing here
        x: 10,
      },
      gridLineWidth: 1,
      lineWidth: 0,
    },
    yAxis: {
      min: 0,
      title: {
        text: "MRs.",
        align: "low",
        margin: -15,
        style: {
          color: "#BF0F15",
        },
        x: -45,
      },
      labels: {
        overflow: "justify",
      },
      gridLineWidth: 0,
    },
    tooltip: {
      useHTML: true,
      headerFormat:
        '<span style="font-size: 12px; color: #000;">Batch: {point.key}</span><br>',
      pointFormatter: function () {
        return `<span style="color:${this.color}; font-weight: bold;">Amount: ${
          this.series.name
        } </span>
                <span style="font-size: 12px;">${Highcharts.numberFormat(
                  this.y,
                  0,
                  ".",
                  ","
                )} MRs.</span>`;
      },
    },
    plotOptions: {
      bar: {
        borderRadius: "50%",
        dataLabels: {
          enabled: false,
        },
        groupPadding: 0.075,
        borderWidth: 0,
      },
      series: {
        pointWidth: 10,
      },
    },
    legend: {
      layout: "vertical",
      align: "right",
      verticalAlign: "bottom",
      x: -40,
      y: 80,
      floating: true,
      borderWidth: 1,
      backgroundColor:
        Highcharts.defaultOptions.legend.backgroundColor || "#FFFFFF",
      shadow: false,
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        name: "",
        color: "#006ad1",
        data: [
          10000, 727, 3202, 721, 632, 727, 3202, 721, 632, 727, 721, 632, 727,
          7210,
        ],
      },
    ],
  });
  const [data, setData] = useState([]);
  const [billingChartXType, setBillingChartXType] = useState(1);
  const [billingChartYType, setBillingChartYType] = useState(1);
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedSubDivision, setSelectedSubDivision] = useState("");
  const [filteredDivisions, setFilteredDivisions] = useState([]);
  const [filteredSubDivisions, setFilteredSubDivisions] = useState([]);
  const [apiData, setApiData] = useState([]);
  const [circleCode, setCircleCode] = useState("");
  const [circleName, setCircleName] = useState("");
  const [officeCode, setOfficeCode] = useState("");
  const [officeName, setOfficeName] = useState("");
  const [hierarchy, setHierarchy] = useState("");
  const [selectedCompanyCode, setSelectedCompanyCode] = useState(
    getInitialAdminOfficeCode(code, selectedAdminCompanyCode),
  );
  useEffect(() => {
    if (String(code) === "10" && selectedAdminCompanyCode) {
      const company = String(selectedAdminCompanyCode);
      setSelectedCompanyCode(company);
      setOfficeCode(company);
    }
  }, [code, selectedAdminCompanyCode]);

  useEffect(() => {
    if (String(code) !== "10") return;
    if (circleCode || selectedDivision || selectedSubDivision) return;
    const company = getEffectiveAdminCompanyCode(
      code,
      selectedCompanyCode,
      selectedAdminCompanyCode,
    );
    if (company) {
      setOfficeCode(company);
    }
  }, [
    code,
    selectedCompanyCode,
    selectedAdminCompanyCode,
    circleCode,
    selectedDivision,
    selectedSubDivision,
  ]);

  const [filteredCircles, setFilteredCircles] = useState([]);
  const [isGoDisabled, setIsGoDisabled] = useState(true);
  const [lastAppliedFilters, setLastAppliedFilters] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [subDivisions, setSubDivisions] = useState(
    JSON.parse(window.localStorage.getItem("subDivisions")) || []
  );
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
  const isPhone = useMediaQuery(theme.breakpoints.down("sm"));
  const [mobileFilterOpen, setMobileFilterOpen] = useState(false);

  const fetchData = async (officeCode) => {
    try {
      setLoading(true);
      const url = `https://ibs-dashboard-data-api.pitc.com.pk/api/v1/common?apiName=eops_payment_todate&P_SDIV=${officeCode}`;
      const response = await fetch(url, {
        method: "GET",
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();

      if (result?.rows) {
        const data = result.rows;
        if (data) {
          setLoading(false);
          setData(result.rows);
        }
      } else {
        setData([]); // No rows
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  function formatToMillions(value) {
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2, // Fixed to 2 decimal places
      maximumFractionDigits: 2,
    }).format(value / Math.pow(10, 6)); // Convert value to millions
  }
  const sumDailyCash = data.reduce((total, batch) => {
    return total + parseFloat(batch.DAILY_CASH);
  }, 0);

  const sumOnlineCash = data.reduce((total, batch) => {
    return total + parseFloat(batch.ONLINE_CASH);
  }, 0);

  const sumTotalCash = data.reduce((total, batch) => {
    return total + parseFloat(batch.TOT_CASH);
  }, 0);
  const sumRCOAMNT = data.reduce((total, batch) => {
    return total + parseFloat(batch.RCO_AMNT);
  }, 0);
  const sumADVAMNT = data.reduce((total, batch) => {
    return total + parseFloat(batch.ADV_PAYMENT);
  }, 0);
  const sumUnidentifiedAMNT = data.reduce((total, batch) => {
    return total + parseFloat(batch.UNID_CASH);
  }, 0);

  const sumPDISCAMNT = data.reduce((total, batch) => {
    return total + parseFloat(batch.PDIS_PAYMENT);
  }, 0);

  const sumGOVTAMNT = data.reduce((total, batch) => {
    return total + parseFloat(batch.GOVT_PAYMENT);
  }, 0);

  const sumTubeWellAMNT = data.reduce((total, batch) => {
    return total + parseFloat(batch.AGRI_PAYMENT);
  }, 0);
  const totalSum = sumRCOAMNT + sumADVAMNT + sumUnidentifiedAMNT;
  const [billingReportPopup, setBillingReportPopup] = useState(false);
  const getLogo = (code) => {
    switch (code) {
      case "10":
        return pitcLogo;
      case "11":
        return LESCOLOGO;
      case "12":
        return GEPCOLOGO;
      case "13":
        return FESCOLOGO;
      case "14":
        return IESCOLOGO;
      case "15":
        return MEPCOLOGO;
      case "26":
        return PESCOLOGO;
      case "27":
        return HAZECOLOGO;
      case "37":
        return HESCOLOGO;
      case "38":
        return SEPCOLOGO;
      case "48":
        return QESCOLOGO;
      case "59":
        return TESCOLOGO;
      default:
        return MEPCOLOGO;
    }
  };
  const getCompanies = (code) => {
    switch (code) {
      case "10":
        return "Power Information Technology Company";
      case "11":
        return "Lahore Electric Supply Company";
      case "12":
        return "Gujranwala Electric Power Company";
      case "13":
        return "Faisalabad Electric Supply Company";
      case "14":
        return "Islamabad Electric Supply Company";
      case "15":
        return "Multan Electric Power Company";
      case "26":
        return "Peshawar Electric Supply Company";
      case "27":
        return "Hazara Electric Supply Company";
      case "38":
        return "Sukkur Electric Power Company";
      case "37":
        return "Hyderabad Electric Supply Company";
      case "48":
        return "Quetta Electric Supply Company";
      case "59":
        return "Tribal Electric Supply Company";
    }
  };
  const DownloadPdf = async (print) => {
    return new Promise((resolve, reject) => {
      let offName = officeName;
      let dateToPrint = getCurrentDateFormatted(new Date());

      // Define header structure
      const headers = [
        [
          {
            content: "Main Date",
            rowSpan: 2,
            valign: "center",
            styles: {
              fillColor: [41, 128, 186],
              textColor: [255, 255, 255],
              fontStyle: "bold",
            },
          },
          {
            content: "Amount Posted",
            colSpan: 3,
            valign: "middle",
            styles: {
              fillColor: [41, 128, 186],
              textColor: [255, 255, 255],
              fontStyle: "bold",
            },
          },
          {
            content: "Amount Collected",
            colSpan: 4,
            valign: "middle",
            styles: {
              fillColor: [41, 128, 186],
              textColor: [255, 255, 255],
              fontStyle: "bold",
            },
          },
          {
            content: "Collection Monitoring",
            colSpan: 3,
            valign: "middle",
            styles: {
              fillColor: [41, 128, 186],
              textColor: [255, 255, 255],
              fontStyle: "bold",
            },
          },
        ],
        [
          {
            content: "Cash (Bank)",
            styles: { fillColor: [41, 128, 186], textColor: [255, 255, 255] },
          },
          {
            content: "Online",
            styles: { fillColor: [41, 128, 186], textColor: [255, 255, 255] },
          },
          {
            content: "Total",
            styles: { fillColor: [41, 128, 186], textColor: [255, 255, 255] },
          },
          {
            content: "RCO Fee",
            styles: { fillColor: [41, 128, 186], textColor: [255, 255, 255] },
          },
          {
            content: "Advance Payment",
            styles: { fillColor: [41, 128, 186], textColor: [255, 255, 255] },
          },
          {
            content: "Unidentified",
            styles: { fillColor: [41, 128, 186], textColor: [255, 255, 255] },
          },
          {
            content: "Total",
            styles: { fillColor: [41, 128, 186], textColor: [255, 255, 255] },
          },
          {
            content: "Govt.",
            styles: { fillColor: [41, 128, 186], textColor: [255, 255, 255] },
          },
          {
            content: "P. Disc.",
            styles: { fillColor: [41, 128, 186], textColor: [255, 255, 255] },
          },
          {
            content: "Tubewell",
            styles: { fillColor: [41, 128, 186], textColor: [255, 255, 255] },
          },
        ],
      ];

      const totals = {
        MAIN_DT: 0,
        DAILY_CASH: 0,
        ONLINE_CASH: 0,
        TOT_CASH: 0,
        RCO_AMNT: 0,
        ADV_PAYMENT: 0,
        UNID_CASH: 0,
        GOVT_PAYMENT: 0,
        PDIS_PAYMENT: 0,
        AGRI_PAYMENT: 0,
      };

      // Define data rows
      const body = data.map((item) => {
        totals.MAIN_DT += parseFloat(item.MAIN_DT) || 0;
        totals.DAILY_CASH += parseFloat(item.DAILY_CASH) || 0;
        totals.ONLINE_CASH += parseFloat(item.ONLINE_CASH) || 0;
        totals.TOT_CASH += parseFloat(item.TOT_CASH) || 0;
        totals.RCO_AMNT += parseFloat(item.RCO_AMNT) || 0;
        totals.ADV_PAYMENT += parseFloat(item.ADV_PAYMENT) || 0;
        totals.UNID_CASH += parseFloat(item.UNID_CASH) || 0;
        totals.GOVT_PAYMENT += parseFloat(item.GOVT_PAYMENT) || 0;
        totals.PDIS_PAYMENT += parseFloat(item.PDIS_PAYMENT) || 0;
        totals.AGRI_PAYMENT += parseFloat(item.AGRI_PAYMENT) || 0;

        return [
          item.MAIN_DT || "-",
          formatToMillions(item.DAILY_CASH) || "-",
          formatToMillions(item.ONLINE_CASH) || "-",
          formatToMillions(item.TOT_CASH) || "-",
          formatToMillions(item.RCO_AMNT) || "-",
          formatToMillions(item.ADV_PAYMENT) || "-",
          formatToMillions(item.UNID_CASH) || "-",
          formatToMillions(item.UNID_CASH + item.ADV_PAYMENT + item.RCO_AMNT) ||
            "-",
          formatToMillions(item.GOVT_PAYMENT) || "-",
          formatToMillions(item.PDIS_PAYMENT) || "-",
          formatToMillions(item.AGRI_PAYMENT) || "-",
        ];
      });

      // Add the "Total" row at the end
      const totalRow = [
        { content: "Total", styles: { fontStyle: "bold" } }, // Set "Total" to bold
        formatToMillions(totals.DAILY_CASH),
        formatToMillions(totals.ONLINE_CASH),
        formatToMillions(totals.TOT_CASH),
        formatToMillions(totals.RCO_AMNT),
        formatToMillions(totals.ADV_PAYMENT),
        formatToMillions(totals.UNID_CASH),
        formatToMillions(
          totals.UNID_CASH + totals.ADV_PAYMENT + totals.RCO_AMNT
        ),
        formatToMillions(totals.GOVT_PAYMENT),
        formatToMillions(totals.PDIS_PAYMENT),
        formatToMillions(totals.AGRI_PAYMENT),
      ];

      body.push(totalRow); // Append the total row to the body

      const pdf = new jsPDF("landscape", "mm", "a4", { compressPdf: true });
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const logoWidth =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        (companyCode === "59") | (companyCode === "27")
          ? 25
          : 30;
      const logoHeight =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        (companyCode === "59") | (companyCode === "27")
          ? 20
          : 10;
      pdf.addImage(getLogo(companyCode), "PNG", 15, 5, logoWidth, logoHeight);

      const eOpsLogoWidth = 20;
      const eOpsLogoHeight = 8;
      const eOpsLogoXPosition =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        (companyCode === "59") | (companyCode === "27")
          ? 43
          : 17;
      pdf.addImage(
        eOpsLogo,
        "PNG",
        eOpsLogoXPosition,
        companyCode === "12" ||
          companyCode === "13" ||
          companyCode === "11" ||
          companyCode === "16" ||
          companyCode === "27" ||
          companyCode === "48" ||
          (companyCode === "59") | (companyCode === "27")
          ? 12
          : 17,
        eOpsLogoWidth,
        eOpsLogoHeight
      );

      pdf.setFontSize(10);
      pdf.text(convertDatewithTime(new Date()), pageWidth - 65, 12);
      pdf.text("Name: " + name, pageWidth - 65, 17);
      if (roleName === "Customer Services Manager") {
        pdf.setFontSize(8); // Reduce font size if the role is 'Customer Services Manager'
      } else {
        pdf.setFontSize(10); // Use default font size for other roles
      }
      pdf.text("Designation: " + roleName, pageWidth - 65, 22);

      pdf.setFontSize(12);
      pdf.text(getCompanies(companyCode), pageWidth / 2, 12, {
        align: "center",
      });
      pdf.text("Cash Collection Summary", pageWidth / 2, 18, {
        align: "center",
      });
      pdf.setFontSize(10);
      pdf.text(
        `${dateToPrint} Cash Collection Summary of ${officeName}`,
        pageWidth / 2,
        25,
        { align: "center" }
      );

      // Generate table in PDF
      pdf.autoTable({
        startY: 28,
        head: headers,
        body: body,
        styles: {
          cellPadding: 1,
          fontSize: 8,
          halign: "center",
          lineWidth: 0.25,
          lineColor: "white",
        },
        margin: { top: 10, left: 15, right: 15 },
        didDrawCell: (data) => {
          // Add vertical lines between specific columns
          const columnsWithVerticalLine = [7]; // Indices of columns after which vertical lines should be drawn
          const cell = data.cell;
          const doc = data.doc;

          if (columnsWithVerticalLine.includes(data.column.index)) {
            const startX = cell.x + cell.width; // Right edge of the current cell
            const startY = cell.y;
            const endY = cell.y + cell.height;
            doc.setDrawColor(0, 0, 0); // Set the color of the line (black)
            doc.setLineWidth(0.5); // Set the thickness of the line
            doc.line(startX, startY, startX, endY); // Draw vertical line
          }
        },
      });

      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        const pageNumberText = `Page ${i} of ${totalPages}`;
        pdf.setFontSize(10);
        pdf.text(pageNumberText, pageWidth - 45, pageHeight - 10);
      }

      // Save or download the PDF
      if (print) {
        pdf.save(`${offName}-${dateToPrint}-cash-collection-summary.pdf`);
      } else {
        resolve(pdf);
      }
    });
  };
  const exportToExcel = () => {
    let dateToPrint = convertDate(new Date());
    // Ensure table ref is defined and points to the table
    if (tableRef.current) {
      const table = tableRef.current;

      // Create a workbook with table data
      const wb = XLSX.utils.table_to_book(table, { sheet: "Sheet1" });

      // Check if "Main Date" column data is included
      const sheet = wb.Sheets["Sheet1"];
      if (!sheet["A1"]) {
        sheet["A1"] = { t: "s", v: "Main Date" }; // Adds header if missing
      }
      boldDomTheadRows(sheet, table, 0);

      // Write workbook to file
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      saveAs(
        new Blob([wbout]),
        `${officeName} - ${dateToPrint} - cash-collection-summary.xlsx`
      );
    } else {
    }
  };

  const printPDF = async () => {
    let pdf = await DownloadPdf(false);
    const pdfUrl = pdf.output("bloburl");
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.top = "-";
    iframe.style.left = "-";
    iframe.style.width = "-";
    iframe.style.height = "-";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    iframe.onload = () => {
      setTimeout(() => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        setTimeout(() => {
          document.body.removeChild(iframe);
        }, 6000);
      }, 3000);
    };
  };

  function getCurrentDateFormatted(date) {
    const day = String(date.getDate()).padStart(2, "0");
    const options = { month: "short" };
    const month = date.toLocaleString("en-US", options);
    const year = String(date.getFullYear()).slice(-2);
    return `${day}-${month}-${year}`;
  }

  // Fetch subDivisions for code == 10
  useEffect(() => {
    if (code == 10 && selectedCompanyCode) {
      const fetchSubDivisions = async () => {
        setLoading(true);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        const formdata = new FormData();
        formdata.append("companyCode", selectedCompanyCode);
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
        };
        try {
          const response = await fetch(
            cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
            requestOptions
          );
          if (response.ok) {
            const result = await response.json();
            if (result.status === "200") {
              setSubDivisions(result.message);
              setApiData(result.message);
              // Populate circles
              const circles = result.message.reduce((acc, curr) => {
                if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                  acc.push({
                    circleCode: curr.circleCode,
                    circleName: curr.circleName,
                    companyCode: curr.companyCode,
                  });
                }
                return acc;
              }, []);
              setFilteredCircles(circles);
            } else {
              setSubDivisions([]);
              setFilteredCircles([]);
            }
          } else {
            throw new Error(`Request failed with status ${response.status}`);
          }
        } catch (error) {
          setSubDivisions([]);
          setFilteredCircles([]);
        } finally {
          setLoading(false);
        }
      };
      fetchSubDivisions();
    } else if (code != 10) {
      // For code != 10, populate circles from localStorage subDivisions
      const circles = subDivisions.reduce((acc, curr) => {
        if (!acc.some((item) => item.circleCode === curr.circleCode)) {
          acc.push({
            circleCode: curr.circleCode,
            circleName: curr.circleName,
            companyCode: curr.companyCode,
          });
        }
        return acc;
      }, []);
      setFilteredCircles(circles);
    }
  }, [code, selectedCompanyCode, token, cfpBaseUrl]);

  const handleChangeCompany = async (e) => {
    const selectedCompany = e.target.value;
    setSelectedCompanyCode(selectedCompany);
    setOfficeCode(selectedCompany);
    setOfficeName(getCompanies(selectedCompany) || "");

    if (code == 10 && selectedCompany) {
      setLoading(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompany);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            // Reset dropdowns
            setCircleCode("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setCircleName("");
            setFilteredDivisions([]);
            setFilteredSubDivisions([]);

            // Populate circles
            const circles = result.message.reduce((acc, curr) => {
              if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                acc.push({
                  circleCode: curr.circleCode,
                  circleName: curr.circleName,
                  companyCode: curr.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredCircles(circles);
          } else {
            setSubDivisions([]);
            setFilteredCircles([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
        setFilteredCircles([]);
      } finally {
        setLoading(false);
      }
    } else if (!selectedCompany) {
      // Reset when no company is selected
      setOfficeName("PITC");
      setCircleCode("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setCircleName("");
      setFilteredDivisions([]);
      setFilteredSubDivisions([]);
      setFilteredCircles([]);
      setSubDivisions([]);
      setApiData([]);
    }
  };

  const handleCircleChange = async (event) => {
    const selectedCircleCode = event.target.value
      ? parseInt(event.target.value)
      : "";
    if (code == 10 && selectedCircleCode && selectedCompanyCode) {
      setLoading(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("circleCode", selectedCircleCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode(selectedCircleCode);
            setOfficeCode(selectedCircleCode);
            const circle = filteredCircles.find(
              (circle) => circle.circleCode === selectedCircleCode
            );
            const circleName = circle?.circleName || "";
            setOfficeName(circleName.concat(" Circle"));
            setCircleName(circleName);
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message
              .filter((item) => item.circleCode === selectedCircleCode)
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (division) => division.divisionCode === item.divisionCode
                  )
                ) {
                  acc.push({
                    divisionCode: item.divisionCode,
                    divisionName: item.divisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setLoading(false);
      }
    } else if (code == 10 && !selectedCircleCode && selectedCompanyCode) {
      // Handle "All Circle" selection for code == 10
      setLoading(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode("");
            setOfficeCode(selectedCompanyCode);
            setOfficeName(getCompanies(selectedCompanyCode));
            setCircleName("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setLoading(false);
      }
    } else if (selectedCircleCode) {
      setCircleCode(selectedCircleCode);
      setOfficeCode(selectedCircleCode);
      const circle = filteredCircles.find(
        (circle) => circle.circleCode === selectedCircleCode
      );
      const circleName = circle?.circleName || "";
      setOfficeName(circleName.concat(" Circle"));
      setCircleName(circleName);
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter((item) => item.circleCode === selectedCircleCode)
        .reduce((acc, item) => {
          if (
            !acc.some((division) => division.divisionCode === item.divisionCode)
          ) {
            acc.push({
              divisionCode: item.divisionCode,
              divisionName: item.divisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    } else {
      // Handle "All Circle" for code != 10
      setCircleCode("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      if (roleTypeName == "Technical") {
        if (offCode) {
          setOfficeCode(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode));
          let officeName = getName(
            String(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode)),
            subDivisions
          );
          setOfficeName(officeName.concat(" Region"));
          setCircleName("");
          const circles = subDivisions.reduce((acc, curr) => {
            if (!acc.some((item) => item.circleCode === curr.circleCode)) {
              acc.push({
                circleCode: curr.circleCode,
                circleName: curr.circleName,
                companyCode: curr.companyCode,
              });
            }
            return acc;
          }, []);
          setFilteredCircles(circles);
          const uniqueDivisions = subDivisions.reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
          setFilteredDivisions(uniqueDivisions);
        }
      } else if (roleTypeName == "Commercial") {
        if (cfcLevelId == 2) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 2));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        } else if (cfcLevelId == 3) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 3));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        }
      }
    }
  };

  const handleDivisionChange = async (e) => {
    const selectedDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedDivisionCode && selectedCompanyCode) {
      setLoading(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("divisionCode", selectedDivisionCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedDivision(selectedDivisionCode);
            setOfficeCode(selectedDivisionCode);
            const division = filteredDivisions.find(
              (division) => division.divisionCode === selectedDivisionCode
            );
            const divisionName = division?.divisionName || "";
            setOfficeName(divisionName.concat(" Division"));
            setSelectedSubDivision("");
            const uniqueSubDivisions = result.message
              .filter((item) => item.divisionCode == selectedDivisionCode)
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (sub) => sub.subDivisionCode === item.subDivisionCode
                  )
                ) {
                  acc.push({
                    subDivisionCode: item.subDivisionCode,
                    subDivisionName: item.subDivisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, []);
            setFilteredSubDivisions(uniqueSubDivisions);
          } else {
            setSubDivisions([]);
            setFilteredSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
        setFilteredSubDivisions([]);
      } finally {
        setLoading(false);
      }
    } else if (selectedDivisionCode) {
      setSelectedDivision(selectedDivisionCode);
      setOfficeCode(selectedDivisionCode);
      const divisionName =
        filteredDivisions.find(
          (division) => division.divisionCode === selectedDivisionCode
        )?.divisionName || "";
      setOfficeName(divisionName.concat(" Division"));
      setSelectedSubDivision("");
      const uniqueSubDivisions = subDivisions
        .filter((item) => item.divisionCode == selectedDivisionCode)
        .reduce((acc, item) => {
          if (
            !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
          ) {
            acc.push({
              subDivisionCode: item.subDivisionCode,
              subDivisionName: item.subDivisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredSubDivisions(uniqueSubDivisions);
    } else {
      setSelectedDivision("");
      setOfficeCode(circleCode ? circleCode : offCode);
      let officeName = getName(
        circleCode ? circleCode.toString() : offCode.toString(),
        subDivisions
      );
      setOfficeName(officeName.concat(" Circle"));
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter(
          (item) => item.circleCode == (circleCode ? circleCode : offCode)
        )
        .reduce((acc, item) => {
          if (
            !acc.some((division) => division.divisionCode === item.divisionCode)
          ) {
            acc.push({
              divisionCode: item.divisionCode,
              divisionName: item.divisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    }
  };

  const handleSubDivisionChange = async (e) => {
    const selectedSubDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedSubDivisionCode && selectedCompanyCode) {
      setLoading(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("subDivisionCode", selectedSubDivisionCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedSubDivision(selectedSubDivisionCode);
            setOfficeCode(selectedSubDivisionCode);
            const subDivision = filteredSubDivisions.find(
              (sub) => sub.subDivisionCode === selectedSubDivisionCode
            );
            const subDivisionName = subDivision?.subDivisionName || "";
            setOfficeName(subDivisionName.concat(" Sub Division"));
          } else {
            setSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
      } finally {
        setLoading(false);
      }
    } else if (selectedSubDivisionCode) {
      setSelectedSubDivision(selectedSubDivisionCode);
      setOfficeCode(selectedSubDivisionCode);
      const subDivisionName =
        filteredSubDivisions.find(
          (sub) => sub.subDivisionCode === selectedSubDivisionCode
        )?.subDivisionName || "";
      setOfficeName(subDivisionName.concat(" Sub Division"));
    } else {
      setSelectedSubDivision("");
      let officeName = getName(
        selectedDivision ? selectedDivision.toString() : offCode.toString(),
        subDivisions
      );
      setOfficeName(officeName.concat(" Division"));
      setOfficeCode(selectedDivision ? selectedDivision : offCode);
    }
  };

  useEffect(() => {
    if (roleTypeName == "Technical") {
      if (offCode) {
        setOfficeCode(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode));
        let offName = getName(
          String(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode)),
          subDivisions
        );
        setOfficeName(offName);
        setHierarchy(offCode.toString().length);
      }
    } else if (roleTypeName == "Commercial") {
      if (cfcLevelId == 1) {
        if (offCode) {
          if (offCode == 10) {
            const effectiveCompany = getEffectiveAdminCompanyCode(
              offCode,
              selectedCompanyCode,
              selectedAdminCompanyCode,
            );
            setOfficeCode(effectiveCompany);
            setOfficeName(getCompanies(String(effectiveCompany)) || "PITC");
          } else {
            setOfficeCode(offCode);
            let offName = getName(offCode, subDivisions);
            setOfficeName(offName);
          }

          setHierarchy(offCode.length);
        }
      } else if (cfcLevelId == 2) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 2));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 3) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 3));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 4) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 4));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            }else if (cfcLevelId == 5) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 5));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            }
    }
  }, [offCode, cfcLevelId, roleTypeName, cscID, selectedAdminCompanyCode, selectedCompanyCode]);

  useEffect(() => {
    if (hierarchy) {
      if (hierarchy == 1 || cfcLevelId === 1) {
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 2 || cfcLevelId == 2) {
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 3 || cfcLevelId == 3) {
        setCircleCode(offCode.slice(0, 3));
        const uniqueDivisions = subDivisions
          .filter((item) => item.circleCode == offCode.slice(0, 3))
          .reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredDivisions(uniqueDivisions);
      } else if (
        hierarchy == 4 ||
        cfcLevelId == 4 ||
        hierarchy == 5 ||
        cfcLevelId == 5
      ) {
        setSelectedDivision(offCode.slice(0, 4));
        const uniqueSubDivisions = subDivisions
          .filter((item) => item.divisionCode == offCode.slice(0, 4))
          .reduce((acc, item) => {
            if (
              !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
            ) {
              acc.push({
                subDivisionCode: item.subDivisionCode,
                subDivisionName: item.subDivisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredSubDivisions(uniqueSubDivisions);
      }
    }
  }, [hierarchy, cfcLevelId, subDivisions]);

  const currentFilters = {
    officeCode,
    ...(code == 10 ? { selectedCompanyCode } : {}),
    circleCode,
    selectedDivision,
    selectedSubDivision,
  };

  useEffect(() => {
    if (lastAppliedFilters === null) {
      setIsGoDisabled(false);
      return;
    }

    const hasChanged =
      JSON.stringify(currentFilters) !== JSON.stringify(lastAppliedFilters);
    setIsGoDisabled(!hasChanged);
  }, [
    officeCode,
    code,
    selectedCompanyCode,
    circleCode,
    selectedDivision,
    selectedSubDivision,
    lastAppliedFilters,
  ]);

  const handleGoClick = () => {
    const reportOfficeCode = resolveReportGoOfficeCode({
      code,
      officeCode,
      selectedCompanyCode,
      selectedAdminCompanyCode,
      circleCode,
      selectedDivision,
      selectedSubDivision,
    });
    fetchData(reportOfficeCode);
    setLastAppliedFilters({ ...currentFilters });
    setIsGoDisabled(true);
    setMobileFilterOpen(false);
  };

   const noDataAvailable = () => {
    alert("No data available to export or print.");
  };

  const FilterFieldLabel = ({ htmlFor, children }) => (
    <Typography
      component="label"
      variant="body2"
      htmlFor={htmlFor}
      sx={{
        fontWeight: 600,
        color: "text.secondary",
        display: "block",
        mb: 0.5,
        lineHeight: 1.35,
      }}
    >
      {children}
    </Typography>
  );

  const tableCaptionText = `Daily Cash Collection Summary for ${officeName || "—"} - (${getCurrentDateFormatted(new Date())}) - Rs. In Million`;

  const renderFilters = ({ showGo = false } = {}) => (
    <Grid
      container
      spacing={2}
      alignItems="flex-start"
      className="coa-filters-grid-wrap"
    >
      {code == 10 && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5}>
            <FilterFieldLabel htmlFor="dcc-company">Company</FilterFieldLabel>
            <FormControl fullWidth size="small" variant="outlined">
              <Select
                id="dcc-company"
                displayEmpty
                value={selectedCompanyCode || ""}
                onChange={(e) => {
                  handleChangeCompany(e);
                  setData([]);
                }}
              >
                <MenuItem value="">
                  <em>Select Company</em>
                </MenuItem>
                <MenuItem value="11">LESCO</MenuItem>
                <MenuItem value="12">GEPCO</MenuItem>
                <MenuItem value="13">FESCO</MenuItem>
                <MenuItem value="14">IESCO</MenuItem>
                <MenuItem value="15">MEPCO</MenuItem>
                <MenuItem value="26">PESCO</MenuItem>
                <MenuItem value="27">HAZECO</MenuItem>
                <MenuItem value="37">HESCO</MenuItem>
                <MenuItem value="38">SEPCO</MenuItem>
                <MenuItem value="48">QESCO</MenuItem>
                <MenuItem value="59">TESCO</MenuItem>
              </Select>
            </FormControl>
          </Stack>
        </Grid>
      )}
      {hierarchy <= 2 && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5}>
            <FilterFieldLabel htmlFor="dcc-circle">Circle</FilterFieldLabel>
            <FormControl fullWidth size="small" variant="outlined">
              <Select
                id="dcc-circle"
                displayEmpty
                value={
                  circleCode === "" ||
                  circleCode === undefined ||
                  circleCode === null
                    ? ""
                    : circleCode
                }
                onChange={(e) => {
                  handleCircleChange(e);
                  setData([]);
                }}
                renderValue={(v) => renderCircleValue(v, filteredCircles)}
              >
                <MenuItem value="">
                  <em>All Circle</em>
                </MenuItem>
                {filteredCircles.map((circle) => (
                  <MenuItem key={circle.circleCode} value={circle.circleCode}>
                    {circle.circleName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Grid>
      )}
      {hierarchy <= 3 && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5}>
            <FilterFieldLabel htmlFor="dcc-division">Division</FilterFieldLabel>
            <FormControl fullWidth size="small" variant="outlined">
              <Select
                id="dcc-division"
                displayEmpty
                value={
                  selectedDivision === "" ||
                  selectedDivision === undefined ||
                  selectedDivision === null
                    ? ""
                    : selectedDivision
                }
                onChange={(e) => {
                  handleDivisionChange(e);
                  setData([]);
                }}
                disabled={!circleCode}
                renderValue={(v) => renderDivisionValue(v, filteredDivisions)}
              >
                <MenuItem value="">
                  <em>All Division</em>
                </MenuItem>
                {filteredDivisions.map((division) => (
                  <MenuItem
                    key={division.divisionCode}
                    value={division.divisionCode}
                  >
                    {division.divisionName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Grid>
      )}
      {hierarchy <= 4 && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5}>
            <FilterFieldLabel htmlFor="dcc-subdiv">Sub-Division</FilterFieldLabel>
            <FormControl fullWidth size="small" variant="outlined">
              <Select
                id="dcc-subdiv"
                displayEmpty
                value={
                  selectedSubDivision === "" ||
                  selectedSubDivision === undefined ||
                  selectedSubDivision === null
                    ? ""
                    : selectedSubDivision
                }
                onChange={(e) => {
                  handleSubDivisionChange(e);
                  setData([]);
                }}
                disabled={!selectedDivision}
                renderValue={(v) =>
                  renderSubDivisionValue(v, filteredSubDivisions)
                }
              >
                <MenuItem value="">
                  <em>All Sub-Division</em>
                </MenuItem>
                {filteredSubDivisions.map((subDivision) => (
                  <MenuItem
                    key={subDivision.subDivisionCode}
                    value={subDivision.subDivisionCode}
                  >
                    {subDivision.subDivisionName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Grid>
      )}
      {showGo && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5} sx={{ pt: "2px" }}>
            <Box
              aria-hidden
              sx={{
                height: "1.35rem",
                mb: 0.5,
                lineHeight: 1.35,
              }}
            />
            <Button
              id="dcc-go-btn"
              fullWidth
              variant="contained"
              disableElevation
              className="coa-go-btn"
              onClick={handleGoClick}
              disabled={isGoDisabled || loading}
            >
              GO
            </Button>
          </Stack>
        </Grid>
      )}
    </Grid>
  );

  return (
    <>
      <Box className="form-box rpt-page coa-status-report cash-collection-summary-page">
        <div className="coa-layout">
          <header className="coa-page-header">
            <h1 className="coa-page-title">Daily Cash Collection Summary</h1>
          </header>

          <div className="coa-toolbar-stack">
            <Paper
              variant="outlined"
              className="coa-card coa-card--filters"
              sx={{
                p: 2,
                width: "100%",
                bgcolor: "#fff",
                borderRadius: 2,
                borderColor: "divider",
              }}
            >
              <div
                className={
                  isMdUp ? "coa-filters coa-filters--mui-grid" : "coa-filters"
                }
              >
                {isMdUp ? (
                  renderFilters({ showGo: true })
                ) : (
                  <p className="coa-filters-hint">
                    Tap <strong>Filters</strong> to choose office, then tap{" "}
                    <strong>GO</strong>.
                  </p>
                )}
              </div>

              <Stack
                direction="row"
                flexWrap="wrap"
                alignItems="center"
                justifyContent={{ xs: "flex-start", md: "flex-end" }}
                spacing={1}
                className="coa-export-strip"
                sx={{
                  pt: 2,
                  mt: 2,
                  borderTop: "1px solid",
                  borderColor: "divider",
                  gap: 1,
                }}
              >
                {!isMdUp && (
                  <Tooltip title="Filters">
                    <IconButton
                      color="primary"
                      onClick={() => setMobileFilterOpen(true)}
                      aria-label="Open filters"
                      size="small"
                    >
                      <FilterListIcon />
                    </IconButton>
                  </Tooltip>
                )}
                {!isMdUp && (
                  <Button
                    variant="contained"
                    disableElevation
                    className="coa-go-btn"
                    size="small"
                    onClick={handleGoClick}
                    disabled={isGoDisabled || loading}
                  >
                    GO
                  </Button>
                )}
                <ReportExportButtons
                  isEmpty={data.length === 0}
                  onEmpty={noDataAvailable}
                  onPdf={() => DownloadPdf(true)}
                  onExcel={exportToExcel}
                  onPrint={printPDF}
                />
              </Stack>
            </Paper>
          </div>

          <div className="coa-report-banner" role="status">
            {tableCaptionText}
          </div>

          <Box
            className="application-table"
            sx={{ width: "100%", maxWidth: "100%", minWidth: 0 }}
          >
            <div className="div-datagrid">
              <div
                className={
                  "coa-table-panel" +
                  (isPhone ? " coa-table-panel--hide-phone" : "")
                }
              >
                <div className="coa-table-scroll" id="pdf-table">
              <div
                ref={tableRef}
                className="cash-collection-tables-wrap"
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 0,
                  width: "100%",
                  minWidth: 0,
                  marginBottom: "30px",
                }}
              >
                <div className="cash-collection-left-wrap">
                <table
                  className="coa-data-table table cash-collection-left"
                  style={{
                    backgroundColor: "white",
                  }}
                >
                  <colgroup>
                    {Array.from({ length: 8 }).map((_, i) => (
                      <col key={i} className="cash-left-col-equal" />
                    ))}
                  </colgroup>
                  <thead>
                    <tr>
                      <th
                        rowSpan={2}
                        style={{
                          backgroundColor: "#d5e5fc",
                          color: "black",
                          padding: "8px 8px",
                          fontSize: "15px",
                          fontFamily: "Roboto-Medium",
                          verticalAlign: "middle",
                        }}
                      >
                        Main Date
                      </th>
                      <th
                        colSpan={3}
                        style={{
                          backgroundColor: "#d5e5fc",
                          color: "black",
                          padding: "8px 10px",
                          fontSize: "16px",
                          fontFamily: "Roboto-Medium",
                        }}
                      >
                        Amount Posted
                      </th>
                      <th
                        colSpan={4}
                        style={{
                          backgroundColor: "#d5e5fc",
                          color: "black",
                          padding: "8px 10px",
                          fontSize: "16px",
                          fontFamily: "Roboto-Medium",
                        }}
                      >
                        Amount Collected
                      </th>
                    </tr>
                    <tr>
                      <th
                        style={{
                          backgroundColor: "#eeeff0",
                          color: "black",
                          fontSize: "13px",
                          fontFamily: "Roboto-Medium",
                          padding: "6px 6px",
                        }}
                      >
                        Cash <br></br>(Bank)
                      </th>
                      <th
                        style={{
                          backgroundColor: "#eeeff0",
                          color: "black",
                          fontSize: "13px",
                          fontFamily: "Roboto-Medium",
                          padding: "6px 6px",
                        }}
                      >
                        Online{" "}
                      </th>
                      <th
                        style={{
                          backgroundColor: "#eeeff0",
                          color: "black",
                          fontSize: "13px",
                          fontFamily: "Roboto-Medium",
                          padding: "6px 6px",
                        }}
                      >
                        Total
                      </th>
                      <th
                        style={{
                          backgroundColor: "#eeeff0",
                          color: "black",
                          fontSize: "13px",
                          fontFamily: "Roboto-Medium",
                          padding: "6px 6px",
                        }}
                      >
                        RCO Fee
                      </th>
                      <th
                        style={{
                          backgroundColor: "#eeeff0",
                          color: "black",
                          fontSize: "13px",
                          fontFamily: "Roboto-Medium",
                          padding: "6px 6px",
                        }}
                      >
                        Advance Payment
                      </th>
                      <th
                        style={{
                          backgroundColor: "#eeeff0",
                          color: "black",
                          fontSize: "13px",
                          fontFamily: "Roboto-Medium",
                          padding: "6px 6px",
                        }}
                      >
                        Unidentified
                      </th>
                      <th
                        style={{
                          backgroundColor: "#eeeff0",
                          color: "black",
                          fontSize: "13px",
                          fontFamily: "Roboto-Medium",
                          padding: "6px 6px",
                        }}
                      >
                        Total
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      // Display loader in place of table data
                      <tr className="coa-loading-row">
                        <td
                          colSpan={8}
                          style={{ textAlign: "center", padding: "20px" }}
                        >
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                          >
                            <AppLoader />
                          </Box>
                        </td>
                      </tr>
                    ) : data.length === 0 ? (
                      <>
                        <tr className="coa-empty-row">
                          <td
                            colSpan={8}
                            style={{
                              textAlign: "center",
                              padding: "10px",
                              fontWeight: "bold",
                              color: "red",
                            }}
                          >
                            No Data Found
                          </td>
                        </tr>
                      </>
                    ) : (
                      <>
                        {data.map((batch, index) => (
                          <tr
                            key={index}
                            style={{ borderBottom: "1px solid #ccc" }}
                          >
                            <td
                              style={{
                                padding: "5px",
                                backgroundColor: "white",
                                textAlign: "center",
                                fontSize: "14px",
                              }}
                            >
                              {batch.MAIN_DT || "-"}
                            </td>
                            <td
                              style={{
                                padding: "5px",
                                backgroundColor: "white",
                                textAlign: "center",
                                fontSize: "14px",
                              }}
                            >
                              {batch.DAILY_CASH
                                ? formatToMillions(batch.DAILY_CASH)
                                : "-"}
                            </td>
                            <td
                              style={{
                                padding: "5px",
                                backgroundColor: "white",
                                textAlign: "center",
                                fontSize: "14px",
                              }}
                            >
                              {batch.ONLINE_CASH
                                ? formatToMillions(batch.ONLINE_CASH)
                                : "-"}
                            </td>
                            <td
                              style={{
                                padding: "5px",
                                backgroundColor: "white",
                                textAlign: "center",
                                fontSize: "14px",
                                color: "#6293cd",
                              }}
                            >
                              {batch.TOT_CASH
                                ? formatToMillions(batch.TOT_CASH)
                                : "-"}
                            </td>
                            <td
                              style={{
                                padding: "5px",
                                backgroundColor: "white",
                                textAlign: "center",
                                fontSize: "14px",
                              }}
                            >
                              {batch.RCO_AMNT
                                ? formatToMillions(batch.RCO_AMNT)
                                : "-"}
                            </td>
                            <td
                              style={{
                                padding: "5px",
                                backgroundColor: "white",
                                textAlign: "center",
                                fontSize: "14px",
                              }}
                            >
                              {batch.ADV_PAYMENT
                                ? formatToMillions(batch.ADV_PAYMENT)
                                : "-"}
                            </td>
                            <td
                              style={{
                                padding: "5px",
                                backgroundColor: "white",
                                textAlign: "center",
                                fontSize: "14px",
                              }}
                            >
                              {batch.UNID_CASH
                                ? formatToMillions(batch.UNID_CASH)
                                : "-"}
                            </td>
                            <td
                              style={{
                                padding: "5px",
                                backgroundColor: "white",
                                textAlign: "center",
                                fontSize: "14px",
                                color: "#6293cd",
                              }}
                            >
                              {(batch.RCO_AMNT || 0) +
                                (batch.ADV_PAYMENT || 0) +
                                (batch.UNID_CASH || 0) >
                              0
                                ? formatToMillions(
                                    (batch.RCO_AMNT || 0) +
                                      (batch.ADV_PAYMENT || 0) +
                                      (batch.UNID_CASH || 0)
                                  )
                                : "-"}
                            </td>
                          </tr>
                        ))}
                        {data && data.length > 0 && (
                          <tr
                            className="coa-total-row"
                            style={{
                              border: "8px solid transparent",
                              backgroundColor: "#fef5c0",
                              padding: "10px 10px",
                              marginTop: "15px",
                              width: "100%",
                            }}
                          >
                            <td
                              style={{
                                borderBottom: "1px solid white",
                                fontWeight: "bold",
                                fontSize: "15px",
                                textAlign: "center",
                              }}
                            >
                              Total
                            </td>
                            <td
                              style={{
                                padding: "5px",
                                color: "black",
                                textAlign: "center",
                                padding: "0px 5px",
                              }}
                            >
                              {sumDailyCash
                                ? formatToMillions(sumDailyCash)
                                : "-"}
                            </td>
                            <td
                              style={{
                                padding: "5px",
                                color: "black",
                                textAlign: "center",
                                padding: "0px 5px",
                              }}
                            >
                              {sumOnlineCash
                                ? formatToMillions(sumOnlineCash)
                                : "-"}
                            </td>
                            <td
                              style={{
                                padding: "5px",
                                color: "black",
                                textAlign: "center",
                                padding: "0px 5px",
                                color: "#6293cd",
                              }}
                            >
                              {sumTotalCash
                                ? formatToMillions(sumTotalCash)
                                : "-"}
                            </td>
                            <td
                              style={{
                                padding: "5px",
                                color: "black",
                                textAlign: "center",
                                padding: "0px 5px",
                              }}
                            >
                              {sumRCOAMNT ? formatToMillions(sumRCOAMNT) : "-"}
                            </td>
                            <td
                              style={{
                                padding: "5px",
                                color: "black",
                                textAlign: "center",
                                padding: "0px 5px",
                              }}
                            >
                              {sumADVAMNT ? formatToMillions(sumADVAMNT) : "-"}
                            </td>
                            <td
                              style={{
                                padding: "5px",
                                color: "black",
                                textAlign: "center",
                                padding: "0px 5px",
                              }}
                            >
                              {sumUnidentifiedAMNT
                                ? formatToMillions(sumUnidentifiedAMNT)
                                : "-"}
                            </td>
                            <td
                              style={{
                                padding: "5px",
                                color: "black",
                                textAlign: "center",
                                padding: "0px 5px",
                                color: "#6293cd",
                              }}
                            >
                              {totalSum ? formatToMillions(totalSum) : "-"}
                            </td>
                          </tr>
                        )}
                      </>
                    )}
                  </tbody>
                </table>
                </div>
                <div
                  className="cash-collection-divider"
                  style={{
                    width: "2px",
                    backgroundColor: "#dc2626",
                  }}
                />
                <div className="cash-collection-right-wrap">
                <table
                  className="coa-data-table table cash-collection-right"
                  style={{
                    backgroundColor: "white",
                  }}
                >
                  <colgroup>
                    <col className="cash-collection-right-col" />
                    <col className="cash-collection-right-col" />
                    <col className="cash-collection-right-col" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th
                        colSpan={3}
                        style={{
                          backgroundColor: "#d5e5fc",
                          color: "black",
                          padding: "8px 8px",
                          fontSize: "14px",
                          fontFamily: "Roboto-Medium",
                          lineHeight: 1.25,
                        }}
                      >
                        Collection Monitoring
                      </th>
                    </tr>
                    <tr>
                      <th
                        style={{
                          backgroundColor: "#eeeff0",
                          color: "black",
                          fontSize: "12px",
                          fontFamily: "Roboto-Medium",
                          padding: "6px 4px",
                        }}
                      >
                        Govt.
                      </th>
                      <th
                        style={{
                          backgroundColor: "#eeeff0",
                          color: "black",
                          fontSize: "12px",
                          fontFamily: "Roboto-Medium",
                          padding: "6px 4px",
                        }}
                      >
                        P. Disc.
                      </th>
                      <th
                        style={{
                          backgroundColor: "#eeeff0",
                          color: "black",
                          fontSize: "12px",
                          fontFamily: "Roboto-Medium",
                          padding: "6px 4px",
                        }}
                      >
                        Tubewell
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      // Display loader in place of table data
                      <tr className="coa-loading-row">
                        <td
                          colSpan={3}
                          style={{ textAlign: "center", padding: "20px" }}
                        >
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                          >
                            <AppLoader />
                          </Box>
                        </td>
                      </tr>
                    ) : data.length === 0 ? (
                      <>
                        <tr className="coa-empty-row">
                          <td
                            colSpan={3}
                            style={{
                              textAlign: "center",
                              padding: "10px",
                              fontWeight: "bold",
                              color: "red",
                            }}
                          >
                            No Data Found
                          </td>
                        </tr>
                      </>
                    ) : (
                      <>
                        {data.map((batch, index) => (
                          <tr
                            key={index}
                            style={{ borderBottom: "1px solid #ccc" }}
                          >
                            <td
                              style={{
                                padding: "5px",
                                backgroundColor: "white",
                                textAlign: "center",
                                fontSize: "14px",
                              }}
                            >
                              {batch.GOVT_PAYMENT
                                ? formatToMillions(batch.GOVT_PAYMENT)
                                : "-"}
                            </td>
                            <td
                              style={{
                                padding: "5px",
                                backgroundColor: "white",
                                textAlign: "center",
                                fontSize: "14px",
                              }}
                            >
                              {batch.PDIS_PAYMENT
                                ? formatToMillions(batch.PDIS_PAYMENT)
                                : "-"}
                            </td>
                            <td
                              style={{
                                padding: "5px",
                                backgroundColor: "white",
                                textAlign: "center",
                                fontSize: "14px",
                              }}
                            >
                              {batch.AGRI_PAYMENT
                                ? formatToMillions(batch.AGRI_PAYMENT)
                                : "-"}
                            </td>
                          </tr>
                        ))}
                        {data && data.length > 0 && (
                          <tr
                            className="coa-total-row"
                            style={{
                              border: "8px solid transparent",
                              backgroundColor: "#fef5c0",
                              padding: "10px 10px",
                              marginTop: "15px",
                              width: "100%",
                            }}
                          >
                            <td
                              style={{
                                padding: "5px",
                                color: "black",
                                textAlign: "center",
                                padding: "0px 5px",
                              }}
                            >
                              {sumGOVTAMNT
                                ? formatToMillions(sumGOVTAMNT)
                                : "-"}
                            </td>
                            <td
                              style={{
                                padding: "5px",
                                color: "black",
                                textAlign: "center",
                                padding: "0px 5px",
                              }}
                            >
                              {sumPDISCAMNT
                                ? formatToMillions(sumPDISCAMNT)
                                : "-"}
                            </td>
                            <td
                              style={{
                                padding: "5px",
                                color: "black",
                                textAlign: "center",
                                padding: "0px 5px",
                              }}
                            >
                              {sumTubeWellAMNT
                                ? formatToMillions(sumTubeWellAMNT)
                                : "-"}
                            </td>
                          </tr>
                        )}
                      </>
                    )}
                  </tbody>
                </table>
                </div>
              </div>
                </div>
              </div>
            </div>
          </Box>

          <Drawer
            anchor="left"
            open={mobileFilterOpen}
            onClose={() => setMobileFilterOpen(false)}
            PaperProps={{
              className: "coa-filter-drawer",
              sx: {
                width: { xs: "100%", sm: 400 },
                maxWidth: "100vw",
                boxSizing: "border-box",
              },
            }}
          >
            <Box
              className="coa-drawer-inner"
              sx={{ p: 2, pb: 3, boxSizing: "border-box" }}
            >
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{ mb: 2 }}
              >
                <Typography variant="h6" component="div">
                  Filters
                </Typography>
                <IconButton
                  aria-label="Close filters"
                  onClick={() => setMobileFilterOpen(false)}
                  edge="end"
                  size="small"
                >
                  <CloseIcon />
                </IconButton>
              </Stack>
              {renderFilters({ showGo: true })}
            </Box>
          </Drawer>
        </div>
      </Box>
    </>
  );
};

export default CashCollectionReport;
